import { render } from "./ViewRolePage.vue?vue&type=template&id=7844bcd8&ts=true"
import script from "./ViewRolePage.vue?vue&type=script&lang=ts"
export * from "./ViewRolePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__